import { useSlow } from '../hooks/useSlow'

/** Architecture §11 / Frontend §4.8 copy. */
export const SLOW_NOTICE = 'This is taking longer than usual…'

/**
 * `<SlowNotice>` (Frontend §4.8): "This is taking longer than usual…" under the busy button or spinner once `pending`
 * has lasted 5 s. The polite live region is always rendered, so screen readers hear the notice when it appears.
 */
export function SlowNotice({ pending, ms }: { pending: boolean; ms?: number }) {
  const slow = useSlow(pending, ms)
  return (
    <p className="slow-notice" role="status">
      {slow ? SLOW_NOTICE : ''}
    </p>
  )
}
